import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CancellationPoliciesCard } from "./component";
import { IStoreState } from "../../../../reducers/types";

import { getIsTripVoidWindowEligible } from "../../../flight-shop/reducer";
import {
  getHotelShopCancellationSummary,
  getHotelShopChosenProduct,
} from "../../../hotel-shop/reducer";
import { getPackagedRoomComponent } from "../../../package-identity/reducer/selectors";
import {
  toCancellationSummary,
  toHotelCancellationPolicyV2,
} from "../../../hotel-shop/utils/packageSnapshotAdapters";

export const mapStateToProps = (state: IStoreState) => {
  const packagedRoomComponentV2 = getPackagedRoomComponent(state);
  const cancellationPolicyV2 = packagedRoomComponentV2?.shopDetails
    ?.cancellationPolicyV2
    ? toHotelCancellationPolicyV2(
        packagedRoomComponentV2.shopDetails.cancellationPolicyV2
      )
    : undefined;

  return {
    chosenProduct: getHotelShopChosenProduct(state),
    isVoidWindowEligible: getIsTripVoidWindowEligible(state),
    cancellationSummary: getHotelShopCancellationSummary(state),
    // v2-sourced: read from the GetPackage snapshot instead of the handoff.
    cancellationPolicyV2,
    cancellationSummaryV2: packagedRoomComponentV2
      ? toCancellationSummary(packagedRoomComponentV2)
      : undefined,
  };
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CancellationPoliciesCardConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCancellationPoliciesCard = withRouter(
  connector(CancellationPoliciesCard)
);
